import { DelegateRole, UserRole } from "./User";

export enum CanvasType {
    DRAWER = "drawer",
    MODAL = "modal",
    FULLSCREEN = "fullscreen",
    NONE = "none",
}

export enum CanvasPresentation {
    OVERLAY = "overlay",
    PUSH = "push",
}

export enum CanvasLocation {
    LEFT = "left",
    RIGHT = "right",
}

export enum TriggerType {
    BUTTON = "button",
    MENU_ITEM = "menuItem",
    AUTOMATIC = "automatic",
}

export type CanvasSize = "small" | "medium" | "large" | "xl" | "2xl";

// Runtime canvas open-request config: the RPC canvas.show payload and the stored dynamic canvas
// share this shape. Narrower than PluginUI, since a dynamically shown canvas is always a drawer
// and carries the runtime context the static manifest does not.
export interface CanvasConfig {
    canvasType?: CanvasType.DRAWER;
    canvasLocation?: CanvasLocation;
    canvasPresentation?: CanvasPresentation;
    canvasSize?: CanvasSize;
    context?: Record<string, unknown>;
}

export interface Plugin {
    id: ID;
    name: string;
    summary: string;
    abilities?: { [key: string]: any };
    description: string;
    logo?: { url: string };
    ui?: PluginUI;
    version: number;
    permissions: Array<UserRole | DelegateRole>;
    config: Array<unknown>;
    beta?: boolean;
    visibility?: {
        xolaAdmin?: boolean;
    };
    user?: {
        id: ID;
    };
}

export interface PluginTrigger {
    type: TriggerType;
    location?: string;
    label?: string;
    icon?: string;
}

interface PluginUI {
    label: string;
    menu: string;
    url: string;
    isEmbeddedApp?: boolean;
    isFirstParty?: boolean;
    triggers?: PluginTrigger[];
    canvasType?: CanvasType;
    canvasSize?: CanvasSize;
    canvasLocation?: CanvasLocation;
    canvasPresentation?: CanvasPresentation;
    embeddedUrl?: string;
    requestedContextFields?: string[];
    apiScopes?: string[];
}
